import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { useContext, useEffect } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";

const useStyles = makeStyles((theme) => ({
  textarea: {
    resize: "both",
  },
  heading: {
    fontSize: "16px",
    fontWeight: 500,
    width: "100%",
    textAlign: "left",
    color: process.env.REACT_APP_COLOR_ACCORDION,
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      minWidth: "80vh",
      borderRadius: "14px",
    },
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogPaper: {
    borderRadius: "20px",
  },
}));

export default function DialogBox(props) {
  const { darkMode, diaLogBoxBlur } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const { onSubmit, children, onClose, ...other } = props;

  const handleClose = () => {
    props.onClose(false);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <Dialog
      aria-labelledby="form-dialog-title"
      className={classes.dialogbox}
      disableEscapeKeyDown
      disableBackdropClick
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
        },
      }}
      {...props}
    >
      {/* Fixed Header */}
      <DialogTitle
        id="form-dialog-title"
        variant="h4"
        style={{
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          position: "sticky",
          top: 0,
          zIndex: 10,
          color: darkMode ? "#fff" : "#000",
          fontSize: "21px",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 15,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        {props.Header}
      </DialogTitle>

      {/* Divider below header */}
      <Divider
        variant="middle"
        style={{
          background: darkMode
            ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
            : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
          height: "1px",
          opacity: 0.5,
        }}
      />

      <div
        style={{
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          paddingBottom: "2px",
          paddingTop: "16px",
          paddingRight: "24px",
          paddingLeft: "24px",
        }}
      >
        {props.children}
      </div>

      {/* Dialog Actions (Footer) */}
      <DialogActions
        style={{
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          position: "sticky",
          bottom: 0,
          zIndex: 10,
        }}
      >
        <CancelButtons onClick={() => props.cancel()}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {props.cancelText}
          </Typography>
        </CancelButtons>
        <SubmitButtons onClick={onSubmit} type="submit">
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {props.acceptText}
          </Typography>
        </SubmitButtons>
      </DialogActions>
    </Dialog>
  );
}
